import React, {forwardRef} from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';
import {AboutMeStyle, TextStyle} from '../assets/css/Styles';
import ProgressBarComponent from './ProgressBarComponent';
import TechnologyContainers from './TehnologyContainers';
import MainTitle from './MainTitle';
import ProfileImage from '../assets/images/clemo.jpg';
// logos
import reactImage from '../assets/images/techLogos/reactlogo2.png';
import nodeImage from '../assets/images/techLogos/nodelogo.png';
import bootstrapImage from '../assets/images/techLogos/bootstraplogo.png';
import couchDBImage from '../assets/images/techLogos/couchDB.png';
import cssImage from '../assets/images/techLogos/csslogo.png';
import electronImage from '../assets/images/techLogos/electron.png';
import expoImage from '../assets/images/techLogos/expo.png';
import expressImage from '../assets/images/techLogos/expresslogo2.png';
import githubImage from '../assets/images/techLogos/githublogo.png';
import gitlabImage from '../assets/images/techLogos/gitlab.png';
import gitImage from '../assets/images/techLogos/gitlogo.png';
import herokuImage from '../assets/images/techLogos/heroku.png';
import htmlImage from '../assets/images/techLogos/htmllogo.png';
import jsImage from '../assets/images/techLogos/jslogo.png';
import cImage from '../assets/images/techLogos/c.png';
import kaliImage from '../assets/images/techLogos/kali.png';
import microsoftImage from '../assets/images/techLogos/microsoft_windows.png';
import mongoImage from '../assets/images/techLogos/mongoDB.png';
import nedbImage from '../assets/images/techLogos/nedb.png';
import npmImage from '../assets/images/techLogos/npm.png';
import postmanImage from '../assets/images/techLogos/postman.png';
import vscodeImage from '../assets/images/techLogos/vscode.png';
import ubuntuImage from '../assets/images/techLogos/ubuntu-logo.png';
import mysqlImage from '../assets/images/techLogos/mysql.png';
import pythonImage from '../assets/images/techLogos/python.png';
import realmImage from '../assets/images/techLogos/realmDB.png';
import reduxImage from '../assets/images/techLogos/reduxlogo2.png';
import firebaseImage from '../assets/images/techLogos/firebase.png';
import sqliteImage from '../assets/images/techLogos/sqlite.png';
import cplusplusImage from '../assets/images/techLogos/cplusplus.png';
import javaImage from '../assets/images/techLogos/java.png';
import wordpressImage from '../assets/images/techLogos/wordpress.png';
import newsapiImage from '../assets/images/techLogos/newsapi.png';
import mochaImage from '../assets/images/techLogos/mochajs.png';
import jestImage from '../assets/images/techLogos/jest.png';
import jasmineImage from '../assets/images/techLogos/jasmine.png';
import karmaImage from '../assets/images/techLogos/karma.png';
import webdriverImage from '../assets/images/techLogos/webdriverIO.png';
import cypressImage from '../assets/images/techLogos/cypress.png';
import testcafeImage from '../assets/images/techLogos/TestCafe.png';
import playwrightImage from '../assets/images/techLogos/playwright.png';


/**
 *
 * @param {Function} ref - ref to a div
 * @return {Component} about me component
 */
export const AboutMe = forwardRef(({ }, ref) => {
  return (
    <div style={AboutMeStyle.aboutMainDiv}>
      <Container ref={ref} style={AboutMeStyle.aboutMeDiv}>
        <MainTitle title='ABOUT ME' />
        <Col style={AboutMeStyle.eachAboutMeDiv}>
          <Row xl='2' lg='2' md='2' sm='1' xs='1'>
            <Col style={AboutMeStyle.aboutMeProfileDiv}>
              <Col>
                <Image
                  src={ProfileImage}
                  alt='clement-pic'
                  style={AboutMeStyle.profilePic}
                  roundedCircle
                />
              </Col>
              <Col style={AboutMeStyle.NameTitle}>
                <span style={TextStyle.subTitleTxt2}>Gyimah Clement</span>
              </Col>
              <Col style={AboutMeStyle.aboutMeDescriptionTxt}>
                <span style={TextStyle.normalTxt2}>
                  I am a Full Stack Engineer and a self-motivated
                  person with a  tremendous passion for Programming.
                  As a machine learning enthusiast,
                  I spend a lot of time doing Data Science.
                  I like to motivate people
                  and help them recognize their potentials.
                  In addition to programming,
                  I work on design projects.
                </span>
              </Col>
            </Col>
            <Col style={AboutMeStyle.progressBarStyleDiv}>
              <ProgressBarComponent title='JavaScript' percentage={80} />
              <ProgressBarComponent title='TypeScript' percentage={85} />
              <ProgressBarComponent title='Python' percentage={60} />
              <ProgressBarComponent title='C++' percentage={40} />
              <ProgressBarComponent title='HTML' percentage={85} />
              <ProgressBarComponent title='CSS' percentage={80} />
              <ProgressBarComponent title='React' percentage={90} />
              <ProgressBarComponent title='React Native' percentage={90} />
              <ProgressBarComponent title='Electron' percentage={90} />
              <ProgressBarComponent title='Arduino' percentage={90} />
            </Col>
          </Row>
        </Col>
        <Col style={AboutMeStyle.eachAboutMeDiv}>
          <Col style={AboutMeStyle.eachTechHeading}>
            <span style={TextStyle.subTitleTxt1}>
              Technologies I Have Worked With
            </span>
          </Col>
          <Row>
            <Col style={AboutMeStyle.eachTecCol}>
              <TechnologyContainers
                title='Frontend'
                techArray={[
                  {name: 'ReactJS and React Native', source: reactImage},
                  {name: 'Bootstrap', source: bootstrapImage},
                  {name: 'CSS', source: cssImage},
                  {name: 'Expo', source: expoImage},
                  {name: 'HTML', source: htmlImage},
                  {name: 'Redux', source: reduxImage},
                  {name: 'Wordpress', source: wordpressImage},
                ]} />
            </Col>
            <Col style={AboutMeStyle.eachTecCol}>
              <TechnologyContainers
                title='Backend'
                techArray={[
                  {name: 'NodeJS', source: nodeImage},
                  {name: 'Firebase', source: firebaseImage},
                  {name: 'ElectronJS', source: electronImage},
                  {name: 'ExpressJS', source: expressImage},
                  {name: 'Google News API', source: newsapiImage},
                ]} />
            </Col>
            <Col style={AboutMeStyle.eachTecCol}>
              <TechnologyContainers
                title='DevOps'
                techArray={[
                  {name: 'Git', source: gitImage},
                  {name: 'GitHub', source: githubImage},
                  {name: 'NPM', source: npmImage},
                  {name: 'GitLab', source: gitlabImage},
                  {name: 'Heroku', source: herokuImage},
                ]} />
            </Col>
            <Col style={AboutMeStyle.eachTecCol}>
              <TechnologyContainers
                title='Languages'
                techArray={[
                  {name: 'JavaScript', source: jsImage},
                  {name: 'Python', source: pythonImage},
                  {name: 'C', source: cImage},
                  {name: 'Java', source: javaImage},
                  {name: 'C++', source: cplusplusImage},
                ]} />
            </Col>
            <Col style={AboutMeStyle.eachTecCol}>
              <TechnologyContainers
                title='Tools'
                techArray={[
                  {name: 'VS Code', source: vscodeImage},
                  {name: 'Postman', source: postmanImage},
                  {name: 'Ubuntu', source: ubuntuImage},
                  {name: 'Kali Linux', source: kaliImage},
                  {name: 'Windows', source: microsoftImage},
                ]} />
            </Col>
            <Col style={AboutMeStyle.eachTecCol}>
              <TechnologyContainers
                title='Database'
                techArray={[
                  {name: 'CouchDB', source: couchDBImage},
                  {name: 'MongoDB', source: mongoImage},
                  {name: 'NeDB', source: nedbImage},
                  {name: 'RealmDB', source: realmImage},
                  {name: 'MySQL', source: mysqlImage},
                  {name: 'SQLite', source: sqliteImage},
                ]} />
            </Col>
            <Col style={AboutMeStyle.eachTecCol}>
              <TechnologyContainers
                title='Testing'
                techArray={[
                  {name: 'Mocha', source: mochaImage},
                  {name: 'Jest', source: jestImage},
                  {name: 'Jasmine', source: jasmineImage},
                  {name: 'Karma', source: karmaImage},
                  {name: 'WebdriverIO', source: webdriverImage},
                  {name: 'Cypress', source: cypressImage},
                  {name: 'Playwright', source: playwrightImage},
                  {name: 'Test Cafe', source: testcafeImage},
                ]} />
            </Col>
          </Row>
        </Col>
      </Container>
    </div>
  );
});
